import {ReactNode} from 'react';

import {ProfileRole} from './profile';

export enum PackageTypes {
    PACK = 'PACK',
    CARTON = 'CARTON',
    BOX = 'BOX',
    PALLET = 'PALLET',
    PRIMARY_PACKAGING = 'PRIMARY_PACKAGING',
    TRANSPORT_PACKAGING = 'TRANSPORT_PACKAGING',
    UNIT = 'UNIT',
    CONTAINER = 'CONTAINER',
    GROUP = 'GROUP',
    CUSTOMS_UNIT = 'CUSTOMS_UNIT',
}

export const statuses = {
    ACTIVE: true,
    INACTIVE: false,
};

export const CUSTOMER_PACKAGE_TYPES = [PackageTypes.UNIT, PackageTypes.GROUP];
export const TRANSPORT_PACKAGE_TYPES = [
    PackageTypes.PALLET,
    PackageTypes.BOX,
    PackageTypes.CONTAINER,
];

export enum OutdatedPackageTypes {
    PACK = 'PACK',
    CARTON = 'CARTON',
    PRIMARY_PACKAGING = 'PRIMARY_PACKAGING',
    TRANSPORT_PACKAGING = 'TRANSPORT_PACKAGING',
}

export enum ProductStatuses {
    PENDING = 'PENDING',
    PUBLISHED = 'PUBLISHED',
}

export enum PackagingType {
    PACKAGE = 'PACKAGE',
    BLISTER = 'BLISTER',
    BOX = 'BOX',
    CARTON = 'CARTON',
    PACKAGING = 'PACKAGING',
    VESSEL = 'VESSEL',
}

export enum GtinStatuses {
    PUBLISHED = 'PUBLISHED',
    PENDING = 'PENDING',
    DRAFT = 'DRAFT',
    REJECTED = 'REJECTED',
    BLOCKED = 'BLOCKED',
}

export enum ActiveStatuses {
    ACTIVE = 'ACTIVE',
    INACTIVE = 'INACTIVE',
}

export enum GtinsAccessors {
    name = 'productName',
    gtin = 'gtin',
    brand = 'productTrademark',
    manufacturer = 'manufacturerName',
    productGroupCode = 'productGroupCode',
    packageType = 'packageType',
    status = 'status',
    isActive = 'isActive',
    isFavorite = 'isFavorite',
    productVersion = 'productVersion',
    updatedAt = 'updatedAt',
}

export interface GtinsGridRawRow {
    productName: string;
    gtin: string;
    productTrademark: string;
    manufacturerName: string;
    productGroupCode: string;
    productId?: string | null;
    packageType: string;
    isActive: boolean;
    isCurrent?: boolean;
    isFavorite?: boolean;
    status: GtinStatuses;
    productVersion: number;
    updatedAt: string;
}

export interface GtinsGridFormattedRow {
    productId?: string | null;
    rawGtin?: string;
    rawIsFavorite?: boolean;
    [GtinsAccessors.name]: string;
    [GtinsAccessors.gtin]: string;
    [GtinsAccessors.brand]: string;
    [GtinsAccessors.manufacturer]?: string;
    [GtinsAccessors.productGroupCode]: ReactNode;
    [GtinsAccessors.packageType]: string;
    [GtinsAccessors.status]: string;
    [GtinsAccessors.isActive]?: boolean;
    [GtinsAccessors.isFavorite]: ReactNode;
    [GtinsAccessors.productVersion]: number;
    [GtinsAccessors.updatedAt]: string;
}

export interface GtinUploadDataItem {
    gtin?: string;
    name?: string;
    vendorCode?: string;
    trademark?: string;
    manufacturerId?: string;
    productId?: string;
}

export interface GtinOrderListItem {
    gtin: string;
    manufacturerName: string;
    productName: string;
    productVendorCode: string;
    productTrademark: string;
    manufacturerId: number;
    productGroupCode: string;
    packageType: PackageTypes;
    productVersion: number;
    productId: string;
}

export interface PackagingFormatType {
    name: string;
    code: string;
    description: string;
}

export interface Country {
    code: string;
    country: string;
    countryFr: string;
}

export interface DeclarationResponsibility {
    declarationType: ProfileRole;
    declarationVersion: string;
    text: string;
    checkboxLabel: string;
    locale: string;
}

export type GtinsViewMode = 'MY' | 'MY_CREATED' | 'ALL';
export type GtinsModeFilter = 'USED_BY_ORDERS' | 'USED_BY_INVOICES' | 'CURRENT';

export interface RecallData {
    batchNumberSource: 'byCode' | 'byCodeAndBatchNumber';
    batchNumber?: string;
    reason: string;
    productCode: string;
    recallDate: Date | null;
    documentNumber: string | null;
    comment: string | null;
}
export interface BrandCreateParams {
    legalOwnerName: string;
    brandName: string;
    country: string;
}
